(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/shared/components/skeleton.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/shared/components/skeleton.js');
'use strict';

const ReactPaper = svs.ui.ReactPaper;

const Skeleton = _ref => {
  let _ref$bottomMargin = _ref.bottomMargin,
    bottomMargin = _ref$bottomMargin === void 0 ? 0 : _ref$bottomMargin,
    _ref$boxHeight = _ref.boxHeight,
    boxHeight = _ref$boxHeight === void 0 ? 1 : _ref$boxHeight,
    _ref$boxWidthProcent = _ref.boxWidthProcent,
    boxWidthProcent = _ref$boxWidthProcent === void 0 ? 100 : _ref$boxWidthProcent,
    _ref$topMargin = _ref.topMargin,
    topMargin = _ref$topMargin === void 0 ? 0 : _ref$topMargin;
  return (
    React.createElement(ReactPaper, {
      isFlat: true,
      isOutlined: false,
      style: {
        margin: 'auto',
        backgroundColor: '#fafaff',
        width: "".concat(boxWidthProcent, "%")
      }
    }, React.createElement("div", {
      style: {
        marginBottom: bottomMargin * 12,
        height: boxHeight * 12,
        marginTop: topMargin * 12
      }
    }))
  );
};
svs.myProfile.react.shared.components.Skeleton = Skeleton;

 })(window);